<template>
  <div>
    <div class="container">
      <div class="reg-header">
        <img src="./../assets/reg_banner.jpg" alt="" />
      </div>
      <div class="sub-header">
        <div class="cn">请完成填写以下信息</div>
        <div class="en">&nbsp;</div>
      </div>
      <div class="main">
        <!-- <p>
          请填写并提交您的设备资料，以便我们为您建立售后服务档案，提供更快速、完善的服务。
        </p>
        <p class="desc-cn">
          Please fill in your equipment information so that we can establish an
          after-sales service file for you and provide quicker and better
          service.
        </p>
        <br /> -->
        <div class="form">
          <div class="form-control">
            <label for="">*姓名</label>
            <input type="text" v-model="form.name" />
          </div>
          <div class="form-control" v-if="online">
            <label for="">*手机</label>
            <input type="text" v-model="form.mobile" />
          </div>
          <div class="form-control" v-if="online">
            <label for="">*职位</label>
            <input type="text" v-model="form.title" />
          </div>
          <div class="form-control">
            <label for="">*邮箱</label>
            <input type="text" v-model="form.email" />
          </div>
          <div class="form-control" v-if="online">
            <label for="">*邮箱验证码</label>
            <div class="group">
              <input type="text" v-model="form.email_code" />
              <button class="mail-verify" @click="verify">发送验证邮件</button>
            </div>
          </div>
          <div class="form-control">
            <label for="">*目标应用</label>
            <select v-model="form.application">
              <option
                :value="type"
                v-for="(type, idx) in applicationTypes"
                :key="idx"
              >
                {{ type }}
              </option>
            </select>
          </div>
          <div class="form-control">
            <label for="">详细需求</label>
            <textarea v-model="form.requirements"></textarea>
          </div>
          <div class="button">
            <button @click="submit()">提交</button>
          </div>
        </div>
      </div>
      <div class="reg-footer">
        <p>联系我们</p>
        <p>
          china.contact@spxflow.com
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast } from "vant";
import { registration, sendVerify } from "../api/request";

const applicationTypes = [
  "乳制品",
  "植物基饮料",
  // "人造奶油",
  "果汁",
  "冰淇淋",
  "调味品",
  "配方奶粉",
  // "电力",
  // "油气",
  // "暖通",
  // "化工/石化",
  // "水处理",
  // "船舶",
  // "空气处理",
  // "矿业",
  "其它",
];

export default {
  data() {
    return {
      online: false,
      index: 0,
      filelist: [],
      form: {
        application: applicationTypes[0],
      },
      applicationTypes,
    };
  },
  methods: {
    async verify() {
      Toast.loading({
        message: "发送邮件...",
        forbidClick: true,
        duration: 3000,
      });
      try {
        await sendVerify(this.form);
        Toast("发送成功!");
      } catch (error) {
        Toast({
          message: error.data.msg,
        });
      }
    },
    async submit() {
      const that = this;
      console.log(this.form);
      Toast.loading({
        message: "提交中...",
        forbidClick: true,
        duration: 0,
      });

      try {
        await registration(this.form);
        Toast("提交成功!");
        setTimeout(() => {
          that.$router.back();
        }, 1000);
      } catch (error) {
        Toast({
          message: error.data.msg,
        });
      }
    },
    delImgs() {},

    async load() {},
  },
  mounted() {
    document.getElementsByClassName("float")[0].style.display = "none";
  },
};
</script>
<style lang="scss" scoped>
.container {
  min-height: calc(100vh - 191px);
  background-color: #d3cccc;
  .reg-header {
    border-bottom: 1px solid #fff;
    img {
      display: block;
      width: 100vw;
    }
  }
  .sub-header {
    background-color: #1d4f48;
    color: #fff;
    padding: 10px;
    .cn {
      font-weight: 700;
      font-size: 17px;
    }
    .en {
      font-size: 12px;
    }
  }
  .main {
    padding: 25px;
    color: #bdbdbd;
    min-height: calc(100vh - 319px);
    .desc-cn {
      margin-top: 10px;
    }
    .upload-desc {
      margin-bottom: 10px;
    }
    .group {
      display: flex;
      button {
        background: #1d4f48;
        color: #fff;
        border-radius: 3px;
        border: none;
        font-size: 12px;
        width: 130px;
        height: 30px;
        margin-left: 10px;
        font-weight: 700;
      }
    }
    .form-control {
      margin-bottom: 10px;
      label {
        color: #1d4f48;
        font-weight: 700;
        font-size: 13px;
        display: block;
        height: 30px;
        line-height: 30px;
      }
      input[type="text"],
      textarea,
      select {
        width: 100%;
        border-radius: 3px;
        border: 1px solid #bdbdbd;
        padding: 0 8px;
        box-sizing: border-box;
        font-size: 12px;
        color: #333;
      }
      input[type="text"],
      select {
        height: 30px;
      }
      textarea {
        padding: 8px;
      }
    }
    .button {
      text-align: right;
      button {
        height: 40px;
        width: 116px;
        background: #1d4f48;
        color: #fff;
        border-radius: 3px;
        border: none;
        font-size: 13px;
        font-weight: 700;
      }
    }
    h3 {
      font-size: 18px;
    }
    h4 {
      font-size: 18px;
      margin-bottom: 30px;
    }
    p {
      font-size: 13.5px;
      color: #1d4f48;
      strong {
        font-weight: 700;
      }
    }
  }
  .reg-footer {
    // background-color: #1d4f48;
    font-weight: 400;
    color: #ededed;
    line-height: 36px;
    text-align: center;
    padding: 10px;
    font-size: 13.5px;
  }
  .phonecall {
    width: 12.5px;
    position: relative;
    top: 1px;
    margin-right: 5px;
  }
  .mail-verify {
    font-size: 11px !important;
  }
}
</style>
